import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function isTokenExpired(token) {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true; // If decoding fails, treat as expired
  }
}

export default function RequireAuth({ children }) {
  const token = localStorage.getItem("jwt_token");

  if (!token || isTokenExpired(token)) {
    localStorage.removeItem("jwt_token"); // Clean up
    window.location.href = "/wiki/";
    return null;
  }

  return children;
}